<template>
  <section class="pet-page">
    <h1 class="title">Pet Therapeutic Device</h1>
    <div class="img-wrap">
      <img src="/img/therapeutic/pet-device.jpeg" alt="Pet Therapeutic Device" />
    </div>
  </section>
</template>

<script>
export default { name: "PetTherapeuticDevice" };
</script>

<style scoped>
.pet-page { padding: 72px 0 }
.title { text-align: center; font-weight: 800; margin-bottom: 16px }
.img-wrap { display: flex; justify-content: center }
.img-wrap img {
  width: 90%;          /* 필요하면 80%로 */
  height: auto;
  border-radius: 8px;
  box-shadow: 0 6px 22px rgba(0,0,0,.08);
}
@media (min-width: 1200px) {
  .img-wrap img { width: 50%; } /* 데스크톱에서 조금 더 줄이기 */
}
</style>
